// extracted by mini-css-extract-plugin
module.exports = {"instructionsList":"NetworkAlert_instructionsList__3y4zZ","instructionsTitle":"NetworkAlert_instructionsTitle__1s2EB","networkName":"NetworkAlert_networkName__3o8kn"};